import addPanelDataConsts from '#packages/addPanelDataConsts';

export default {
  type: addPanelDataConsts.SECTIONS_TYPES.PERSONALIZED,
  hide: false,
  title: 'add_section_label_my_boxes_only',
  subNavigationTitle: 'add_section_label_my_boxes_only',
  presetTitle: 'add_section_label_my_boxes_only',
  tooltipTitle: 'add_section_label_my_boxes_only',
  subNavigationHide: false,
  showSectionHeader: true,
  additionalBehaviours: {
    labelMode: addPanelDataConsts.LABEL_BEHAVIOUR.NONE,
    infoIcon: addPanelDataConsts.INFO_ICON_BEHAVIOUR.NONE,
    iconEnabledForComps: [],
  },
  props: {
    compTypes: [
      'mobile.core.components.Container',
      'core.components.Container',
    ],
    verticalMargin: 30,
    horizontalMargin: 20,
    scaleProportion: {
      x: 0.5,
      y: 0.5,
    },
  },
  help: {
    hide: false,
    text: 'add_section_info_text_my_general',
  },
};
